module.exports = __webpack_public_path__ + "static/social_opensea-db0af211397b75cea7c73149a35ac71d.png";